import * as Immutable from 'immutable';
import { PLATFORM } from '../constants/SiteVariables'

function platforms(d, s, p) {
  switch(PLATFORM(false)) {
    case 'development':
      return d ? true : false;

    case 'staging':
      return s ? true : false;

    case 'production':
      return p ? true : false;

    default:
      return true;
  }
}

const flagState = Immutable.fromJS({
  followers: platforms(true, false, true),
  social: platforms(true, true, true),
  specials: platforms(true, true, true),
  deals: platforms(true, true, true)
});

/*function setState(state, newState) {*/
  //return state.merge(newState);
/*}*/

export function flag(state = flagState, action) {
  /*switch(action.type) {*/
    //default:
      //return state;
  /*}*/

  return state;
}



// WEBPACK FOOTER //
// ./src/reducers/flag.js